<mat-card class="default has-progress-bar" data-balance-charges-panel>
  <mat-progress-bar
    [mode]="estimateChargesLoading() ? 'indeterminate' : 'determinate'"
  ></mat-progress-bar>
  <mat-card-title
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="10px"
  >
    <span fxFlex>{{ 'estimate.charges' | translate }}</span>
    <button
      mat-stroked-button
      [matMenuTriggerFor]="resetEstimateMenu"
      [matTooltip]="'dialog.charges.reset.tooltip' | translate"
      (click)="$event.preventDefault()"
    >
      <mat-icon>restart_alt</mat-icon>
      <span>{{ 'common.reset' | translate }}</span>
    </button>
    <button
      *ngIf="estimateTemplatesEnabled()"
      mat-stroked-button
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="estimateMenu"
    >
      <span>{{ 'common.template' | translate }}</span>
    </button>
  </mat-card-title>
  <mat-card-content [formGroup]="estimateForm()">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between start"
      fxLayoutGap="1rem"
      class="mb-2"
    >
      <mat-form-field *ngIf="!shopper()" fxFlex subscriptSizing="dynamic" data-balance-charges-appointment-picker>
        <mat-label>{{ 'common.appointments' | translate }}</mat-label>
        <mat-select
          formControlName="appointmentIds"
          multiple
          (selectionChange)="addChargesByAppointments(false)"
        >
          <mat-option
            *ngFor="let option of appointmentOptions()"
            [value]="option.value"
            [disabled]="option.disabled"
          >
            <span *ngIf="option.appointment.startAt; else order">{{
              option.appointment.startAt | momentDateTime
            }}</span>
            <ng-template #order>
              <span>{{ 'common.order' | translate }}</span>
            </ng-template>
            <ng-container *ngIf="option.hint; else noProcedureCodes">
              ({{ option.hint }})</ng-container
            >
            <ng-template #noProcedureCodes>
              <span class="text-warn" class="ml-2"
                >(Appointment has no CPT codes)</span
              >
            </ng-template>
            <span class="text-warn" *ngIf="option.hasEstimate">
              - {{ 'dialog.charges.appt-included' | translate }}
            </span>
            <span *ngIf="option.visitNumber">
              - {{ "charges-table.form.visit-number-item" | translate : {number: option.visitNumber} }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field fxFlex subscriptSizing="dynamic">
        <mat-label>{{ 'common.facility' | translate }}</mat-label>
        <mmx-facility-selector-input
          formControlName="facilityId"
          required
        ></mmx-facility-selector-input>
        <mat-error *ngIf="estimateForm().controls.facilityId.hasError('required')">{{ "charges-table.form.facility-required" | translate }}</mat-error>
      </mat-form-field>
    </div>
    <ng-container *ngIf="claimSearchEnabled()">
      <mmx-model-claim-search
        *mmxHasAccess="'estimate.model-claim-search'"
        [facilityId]="estimateForm().value.facilityId"
        [serviceType]="estimate().patientType || PATIENT_TYPE.OutPatient"
        [physicianId]="selectedPhysicianId()"
        [prefillQuery]="modelClaimSearchQuery$ | async"
        (modelClaim)="addClaim($event)"
      ></mmx-model-claim-search>
    </ng-container>
    @if(estimate()) {
      <mmx-charges-table-form
        [facilityIds]="[estimateForm().value.facilityId]"
        [chargesFormArray]="chargesFormArray"
        [appointmentOptions]="appointmentOptionsView()"
        (change)="markDirty()"
        (valueUpdated)="markDirty()"
        (addChargeDiscountControl)="onAddChargeDiscountControl($event)"
        (removeChargeDiscountControl)="onRemoveChargeDiscountControl($event)"
      ></mmx-charges-table-form>
    }
  </mat-card-content>
</mat-card>
<mat-menu #resetEstimateMenu="matMenu">
  <button
    mat-menu-item
    *ngIf="estimateForm().value.appointmentIds?.length > 0"
    (click)="resetEstimateFormEvent('appointment')"
  >
    <span> {{ 'dialog.charges.reset.by-appointment' | translate }}</span>
  </button>
  <button
    mat-menu-item
    *ngIf="estimate().templateId"
    (click)="resetEstimateFormEvent('template')"
  >
    <span> {{ 'dialog.charges.reset.by-template' | translate }}</span>
  </button>
  <button
    mat-menu-item
    *ngIf="estimate().id"
    (click)="resetEstimateFormEvent('estimate')"
  >
    <span> {{ 'dialog.charges.reset.by-estimate' | translate }}</span>
  </button>
  <button mat-menu-item color="warn" (click)="resetEstimateFormEvent('clear')">
    <mat-icon color="warn">clear</mat-icon>
    <span> {{ 'dialog.charges.reset.all' | translate }}</span>
  </button>
</mat-menu>
<mat-menu #estimateMenu="matMenu">
  <mmx-estimate-template-menu
    (click)="$event.stopPropagation()"
    [facilityId]="estimateForm().controls.facilityId.value"
    (templateSelected)="onTemplateSelected($event)"
  ></mmx-estimate-template-menu>
</mat-menu>
